import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import { Checkbox } from '@/components/ui/checkbox'

import { GraduationCap as UniIcon } from 'lucide-react'

import { educationItems } from '@/app/(main)/contest/submit/constants'
import { Control } from 'react-hook-form'
import { PreferenceFormSchema } from '../../preference/form'
import { FormField } from '@/components/ui/form'

interface EducationalLevelAccordionProps {
  control: Control<PreferenceFormSchema>
}

export function EducationalLevelAccordion({
  control,
}: EducationalLevelAccordionProps) {
  return (
    <AccordionItem value="item-1">
      <div className="mb-2">
        <AccordionTrigger>
          <div className="flex h-[10px] items-center gap-2 px-3 text-[12px]">
            <UniIcon className="text-[12px]" />
            <p>ระดับการศึกษา</p>
          </div>
        </AccordionTrigger>
      </div>
      <div className="px-5">
        <AccordionContent>
          <FormField
            control={control}
            name="educationalLevels"
            render={({ field }) => {
              return (
                <div className="space-y-2">
                  {educationItems.map((item) => (
                    <div key={item.id} className="items-top flex space-x-2">
                      <Checkbox
                        id={item.id}
                        checked={field?.value?.includes(item.id)}
                        onCheckedChange={(checked) => {
                          if (checked) {
                            field.onChange([...field?.value, item.id])
                          } else {
                            field.onChange(
                              [...field?.value].filter((id) => id !== item.id)
                            )
                          }
                        }}
                      />
                      <div className="grid gap-1.5 leading-none">
                        <label
                          htmlFor={item.id}
                          className="text-sm font-[14px] leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                        >
                          {item.label}
                        </label>
                      </div>
                    </div>
                  ))}
                </div>
              )
            }}
          />
        </AccordionContent>
      </div>
    </AccordionItem>
  )
}
